__turbopack_context__.v({
  "backButton": "DDzrVW_backButton",
  "buttonGroup": "DDzrVW_buttonGroup",
  "rtl": "DDzrVW_rtl",
});
